import * as types   from "../../constants/action-types";

let initialState = {
    showLoader: false,
    deviceState: '',
    burgerMenuState: false,
    burgerMenuAnimate: false,
    popupsArray: [],
    requesting: false,
}

export default function state_reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_DEVICE_STATE:
            return {
                ...state,
                deviceState: action.payload
            };
        case types.SET_BURGER_STATE:
            return {
                ...state,
                burgerMenuState: action.payload
            };
        case types.SET_BURGER_ANIMATE:
            return {
                ...state,
                burgerMenuAnimate: action.payload
            };
        case types.SET_CURRENT_POPUP:
            return {
                ...state,
                popupsArray: [...state.popupsArray, action.payload]
            };
        case types.REMOVE_CURRENT_POPUP:
            return {
                ...state,
                popupsArray: [...state.popupsArray.slice(0,-1)]
            };
        case types.SET_REQUEST_STARTED:
            return {
                ...state,
                requesting: true
            };
        case types.SET_REQUEST_ENDED:
            return {
                ...state,
                requesting: false
            };
        default:
            return state;
    }
}
